import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {AdditionalEditComponent} from "./additional-edit.component";
import {AdditionalRoutingModule} from "./additional-routing.module";
import {SharedModule} from "../../shared/shared.module";
import {BrowserModule} from "@angular/platform-browser";

@NgModule({
    imports: [CommonModule,BrowserModule, FormsModule, ReactiveFormsModule, TranslateModule,
        SharedModule, AdditionalRoutingModule],
    declarations: [
        AdditionalEditComponent
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AdditionalModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/additional/additional.module.ts